import styles from './ActionButtons.module.css';
import voucherIcon from '/voucher.svg';
import spinIcon from '/spin.svg';
import taskIcon from "/TaskIcon.svg";
const BUTTONS = {
  voucher: {
    icon: voucherIcon,
    alt: "Ваучеры",
    text: "Ваучеры",
    className: styles.voucherButton,
  },
  spin: {
    icon: spinIcon,
    alt: 'Крутить',
    text: 'Крутить',
    loadingText: 'Крутить',
    loadingStateText: 'Крутить',
    className: styles.spinButton
  },
  tasks: {
    icon: taskIcon,
    alt: 'Задания',
    text: 'Задания',
    className: styles.taskButton
  }
};

const ActionButtons = ({
  onVouchersClick,
  onTasksClick,
  onSpinClick,
  tickets = 0,
  disabled = false,
  isLoading = false,
  setNotification,
}) => {
  const getSpinButtonClass = () => {
    const baseClass = BUTTONS.spin.className;
    const stateClass =
      tickets > 0 && !disabled ? styles.active : styles.inactive;
    return `${baseClass} ${stateClass}`;
  };

  const handleSpinClick = () => {
    if (tickets <= 0) {
      setNotification({
        type: "Error",
        message: "Выполняй задания и получай билеты чтобы крутить колесо",
      });

      return;
    }
    onSpinClick();
  };

  const renderButton = ({
    icon,
    alt,
    text,
    className,
    onClick,
    isSpinButton = false,
  }) => (
    <button
      onClick={isSpinButton ? handleSpinClick : onClick}
      className={isSpinButton ? getSpinButtonClass() : className}
      disabled={isSpinButton ? disabled || isLoading : false}
    >
      <img src={icon} alt={alt} />
      {isSpinButton
        ? isLoading
          ? BUTTONS.spin.loadingStateText
          : disabled
          ? BUTTONS.spin.loadingText
          : text
        : text}
    </button>
  );

  return (
    <div className={styles.actionButtons}>
      {renderButton({
        ...BUTTONS.voucher,
        onClick: onVouchersClick,
      })}
      {renderButton({
        ...BUTTONS.tasks,
        onClick: onTasksClick
      })}
      {renderButton({
        ...BUTTONS.spin,
        onClick: onSpinClick,
        isSpinButton: true,
      })}
    </div>
  );
};

export default ActionButtons;
